module.exports = __webpack_public_path__ + "img/chevron-up.dea89159.svg";